<template>
  <header><!-- Empty header to flex align things vertically properly with footer --></header>
  <main class="boxed-container">
    <div class="logos">
      <img class="logo-primary" :src="'../de.elo.ix.plugin.rest/auth2/branding/logo-primary'" alt="logo-primary" />
      <img class="logo-secondary" :src="'../de.elo.ix.plugin.rest/auth2/branding/logo-secondary'"  alt="logo-secondary" />
    </div>
    <suspense>
      <template #fallback>
        <b-loading />
      </template>
      <slot></slot>
    </suspense>
  </main>
  <footer>{{license}}</footer>
</template>

<style>
@import '../css/theme.css';

body {
  background: #E7E8E9 none;
  background-size: cover;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}


.boxed-container {
  background-color: white;
  width: 480px;
  border-radius: 4px;
  text-align: center;
  padding: 40px;
}

@media only screen and (max-width: 480px) {
  .boxed-container {
    flex: 1;
    border-radius: 0;
    width: 100%;
  }
}

.logos {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
}

.logo-primary {
  height: 48px;
}

.logo-secondary {
  height: 32px;
}

section {
  margin: 1rem 0;
}

section:first-child {
  margin-top: 0;
}

section:last-child,
section:has(+ footer) {
  margin-bottom: 0;
}

#app > footer {
  width: 100%;
  padding: 8px;
  background-color: #FFFFFF;
  text-align: center;
}
</style>

<script setup lang="ts">
import '@elo/ui-buefy-v3/dist/elo-ui.css';
import '@elo/font-elo-sans-pro';
import '../css/e-icons.css';
import {API_URL, fetchJson} from "../ts/utils"; // EAUTH2-33
import {ref, Suspense} from 'vue'

document.body.style.backgroundImage = `url('${API_URL}/branding/background')`;

const license = ref('ELO Digital Office');


fetchJson(API_URL + '/status').then((status) => {
  license.value = status.license;
}).catch((e) => {
  license.value = `Failed to get Auth2 Plugin status: ${e}`;
});
</script>
